import React, {useContext} from 'react';
import IndicatorsContextProvider from './IndicatorsContextProvider';
import IndicatorsContext from './IndicatorsContext';
import LoadingPage from "../../../views/LoadingPage";

/**
 * Inserts UserContextProvider in the react tree
 * before adding the given component.
 *
 * @param {Object} Component The component that needs the context provider.
 * @returns {Object} The component to render wrapped with the provider.
 */
const withIndicatorsContextProvider = (Component) => (props) => (
    <IndicatorsContextProvider>
        <Component {...props} />
    </IndicatorsContextProvider>
);

/**
 * Renders the given component when the user context is ready.
 *
 * @param {Object} Component The component to render.
 * @param {Object} Component The rendered component.
 * @returns {Object} The component to render or the LoadingPage component.
 */
const withIndicatorsContextReady = (Component) => (props) => {

    const {isReady} = useContext(IndicatorsContext);
    return isReady ? <Component {...props} /> :
        <LoadingPage/>
};

export {
    withIndicatorsContextReady,
    withIndicatorsContextProvider,
};